import { request, Response } from '../utils';
import { Session, V1GraphForStorage } from '../types';

export const updateGraph = (body: {
  session: Session;
  data: V1GraphForStorage;
}): Response<null> => request('update-graph', body);
